import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_STEEL_BRANDS);

const BCMBrandSteel = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_STEEL_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['TATA Steel', 'JSW Steel', 'SAIL', 'Jindal Steel', 'Welspun']}
      icon={PROFILER_IMAGES.steel_tmt}
      {...props}
    />
  )
}

export default BCMBrandSteel
